import { OfficialProductSetup } from "@/mocks/data/officialProductSetupService/officialProductSetup";

const productSetupInformation = {
  getProductSetupDropdownData: async (): Promise<any> => {
    try {
      // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
      const resp = OfficialProductSetup;
      return resp ?? null;
    } catch (error) {
      console.error("Error fetching vendor data:", error);
      throw error;
    }
  },
};

export default productSetupInformation;